import Slider from './slider'

class AboutSlider extends Slider {
    constructor(selector, navGroupSelector, options) {
        super(selector, options);
        this.setNav(navGroupSelector);
        this.$titleContentTarget = $(selector).parent().find('.mobile-title h3');
    }

    setNav(navGroupSelector) {
        this.$cellButtonGroup = $(navGroupSelector);

        this.$cellButtonGroup.on('click', '.js-slider-nav', (e) => {
            var index = $(e.currentTarget).index();
            this.setNavActive(index);
            this.flkty.select(index, true, false);
        });

        this.flkty.on('cellSelect', () => {
            var $sliderCells = this.$fickityInstance.find('.slide'),
                $currentSlide = $sliderCells.eq(this.flkty.selectedIndex),
                $titleContentText = $currentSlide.find('.slide-title-hidden').text();

            this.setNavActive(this.flkty.selectedIndex);

            this.$titleContentTarget.fadeOut('fast', () => {
                this.$titleContentTarget.text($titleContentText).fadeIn('fast');
            });
        });
    }

    setNavActive(index) {
        this.$cellButtonGroup.find('.js-slider-nav').removeClass('active').eq(index).addClass('active');
    }
}

module.exports = AboutSlider;